import NewSwitch from "pages/business/Subscription/NewSwitch";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const ProductsSetting = (props:any) => {
   const navigate = useNavigate();
    // @ts-ignore
    const { business, token } = useSelector((state) => state).businessReducer.business;
  
    const { settingData, setSettingData } = props;
  
    const onChange = (key: any, value: any) => {
      let temp = {
        ...settingData,
        [key]: value
      };
      setSettingData(temp);
    };
  
    return (
      <>
      <div className="flex container flex-col ">
        {userData.map((item, index) => (
          <div key={index} className="flex flex-row items-center w-full py-4 mb-6">
            <NewSwitch
              active={settingData[item.key] || undefined}
              activeColor="#30D74B"
              size={2}
              onChange={(value) => onChange(item.key, value)}
            />
            <div className="flex flex-col justify-end px-4">
              <h1 className="text-base font-medium text-dark-6 ">{item.label}</h1>
              <span className="text-xs font-normal text-dark-3 mt-4">{item?.description}</span>
            </div>
          </div>
        ))}
      </div>
      </>
    )
}
 
export default ProductsSetting;
const userData=[
    {
        label: "ثبت کالا با بارکد تکراری",
        description: "با فعال بودن این گزینه، محصول با بارکد تکراری ثبت می شود",
        key: "duplicateBarcode",
        timeSetting: null
      }
]